import { useQuery } from '@tanstack/react-query'
import { getAgendasService } from '@/services/agendas'

export const AGENDAS_QUERY_KEY = ['agendas']

export const useAgendas = () =>
  useQuery({
    queryKey: AGENDAS_QUERY_KEY,
    queryFn: getAgendasService,
  })
